import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { formatInputVariable } from "@/utils/evaluate";

interface ValueSourceSelectorProps {
  valueSource: string | null;
  onValueSourceChange: (source: string) => void;
  availableSources: string[];
  disabled?: boolean;
}

const ValueSourceSelector = ({
  valueSource,
  onValueSourceChange,
  availableSources,
  disabled = false,
}: ValueSourceSelectorProps) => (
  <Select value={valueSource ?? undefined} onValueChange={onValueSourceChange} disabled={disabled}>
    <SelectTrigger className="w-full">
      <SelectValue placeholder="Select a source..." />
    </SelectTrigger>
    <SelectContent>
      {availableSources.map(source => (
        <SelectItem key={source} value={source}>
          {formatInputVariable("unknown", source)}
        </SelectItem>
      ))}
    </SelectContent>
  </Select>
);

export default ValueSourceSelector;
